<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container >
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item aria-label="員工入口" :label="this.language['emp.develop.empEntrance']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="entranceList">
              <a-checkbox-group v-model="model.entranceList" @change="handleChangeEntrance" :disabled="formDisabled" >
                <!--                <div v-for="(item,index) in entranceOptions" :key="index">-->
                <a-checkbox v-for="(item,index) in entranceOptions" :key="index" :value="item.value" >{{item.label}}</a-checkbox>
                <!--                </div>-->
              </a-checkbox-group>
            </a-form-model-item>
          </a-col>

          <div v-for="(item,index) in selectedEntrances" :key="index">
            <a-form-model-item aria-label="应用分类" :label="language['emp.develop.appType']+cale(item)" :labelCol="labelCol" :wrapperCol="wrapperCol" class="requiredCss">
              <a-select show-search :placeholder="language['column.pleaseChoose']+language['emp.develop.appType']"
                        :disabled="formDisabled" v-model="appData[index]" >

                <a-select-option v-for="(item1,index) in apptypeOptions.filter(temp => temp.entranceId === item)" :key="index" :value="item1.value" allowClear >
                  {{ item1.label }}
                </a-select-option>
              </a-select>
              <!--              <Component :modelValue="inputValue" @update:modelValue="updateValue" />-->

            </a-form-model-item>
          </div>
          <a-col :span="24">
            <a-form-model-item :label="this.language['emp.develop.appName']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="applicationName">
              <a-input v-model="model.applicationName" :placeholder="this.language['basedata.pleaseEnter']+this.language['emp.develop.appName']"  :disabled="true" style="width: 85%" ></a-input>
              <a-button @click="languageModelOpen('emp_dev_app_apply','application_name',applicationNameLanguages)" type="primary"  style="left: 3%" >{{language['common.language']}}</a-button>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item  :label="this.language['emp.develop.appCode']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="applicationCode">
              <a-input v-model="model.applicationCode" :placeholder="this.language['basedata.pleaseEnter']+this.language['emp.develop.appCode']"  :disabled="true"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="this.language['emp.develop.appIcon']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="applicationImgPath">
<!--              <a-input v-model="model.applicationImgPath" placeholder="请输入应用图标"  ></a-input>-->
              <j-image-upload v-model="model.applicationImgPath" :disabled="true"></j-image-upload>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="this.language['emp.develop.appDesc']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="applicationDesc">
              <a-textarea v-model="model.applicationDesc" :placeholder="this.language['basedata.pleaseEnter']+this.language['emp.develop.appDesc']"  :disabled="true" style="width: 85%" rows="4"></a-textarea>
              <a-button @click="languageModelOpen('emp_dev_app_apply','application_desc',applicationDescLanguages)" type="primary"  style="left: 3%" >{{language['common.language']}}</a-button>
            </a-form-model-item>
          </a-col>
<!--          <a-col :span="24">
            <a-form-model-item :label="this.language['emp.develop.joinTypeTitle']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="joinType">
              <a-input v-model="model.joinType_dictText" placeholder=""  ></a-input>
            </a-form-model-item>
          </a-col>-->
<!--          <a-col :span="24">
            <a-form-model-item aria-label="应用中心加入类型" :label="this.language['emp.develop.joinTypeTitle']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="joinType">
              <a-radio-group v-model="model.joinType"  :disabled="true">
                <a-radio aria-text="Link加入" value='link'>
                  {{ this.language['emp.develop.linkJoin'] }}
                </a-radio>
                <a-radio aria-text="SSO加入" value='sso'>
                  {{ this.language['emp.develop.ssoJoin'] }}
                </a-radio>
                <a-radio aria-text="授权加入" value='authorize'>
                  {{ this.language['emp.develop.authJoin'] }}
                </a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>-->
          <a-col :span="24">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              prop="joinType"
              aria-label="应用中心加入类型" :label="language['emp.develop.joinTypeTitle']" >
              <j-dict-select-tag v-model="model.joinType" :allowClear="true" dictCode="emp_application_jointype" :disabled="true"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item aria-label="应用URL（测试）" :label="language['emp.develop.appUrlTest']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="applicationTestUrl" v-if="this.model.joinType=='link'">
              <a-input v-model="model.applicationTestUrl" :placeholder="language['common.pleaseInput']+language['emp.develop.appUrlTest']"   ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item aria-label="应用URL（正式）" :label="language['emp.develop.appUrlProd']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="applicationProdUrl" v-if="this.model.joinType=='link'">
              <a-input v-model="model.applicationProdUrl" :placeholder="language['common.pleaseInput']+language['emp.develop.appUrlProd']"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item aria-label="SSO回传URL（测试）" :label="language['emp.develop.ssoUrlTest']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="applicationTestUrl" v-if="this.model.joinType=='sso'">
              <a-input v-model="model.applicationTestUrl" :placeholder="language['common.pleaseInput']+language['emp.develop.ssoUrlTest']"   ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item aria-label="SSO回传URL（正式）" :label="language['emp.develop.ssoUrlProd']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="applicationProdUrl" v-if="this.model.joinType=='sso'">
              <a-input v-model="model.applicationProdUrl" :placeholder="language['common.pleaseInput']+language['emp.develop.ssoUrlProd']"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item aria-label="应用授权URL（测试）" :label="language['emp.develop.authUrlTest']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="applicationAuthTestUrl" v-if="this.model.joinType=='authorize'">
              <a-input v-model="model.applicationAuthTestUrl" placeholder="请输入应用授权URL（测试）"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item aria-label="应用授权URL（正式）" :label="language['emp.develop.authUrlProd']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="applicationAuthProdUrl" v-if="this.model.joinType=='authorize'">
              <a-input v-model="model.applicationAuthProdUrl" :placeholder="language['common.pleaseInput']+language['emp.develop.authUrlProd']"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item aria-label="免登录URL（测试）" :label="language['emp.develop.ssoLoginUrlTest']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="applicationTestUrl" v-if="this.model.joinType=='authorize'">
              <a-input  v-model="model.applicationTestUrl" :placeholder="language['common.pleaseInput']+language['emp.develop.ssoLoginUrlTest']" ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item aria-label="免登录URL（正式）" :label="language['emp.develop.ssoLoginUrlProd']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="applicationProdUrl" v-if="this.model.joinType=='authorize'">
              <a-input  v-model="model.applicationProdUrl" :placeholder="language['common.pleaseInput']+language['emp.develop.ssoLoginUrlProd']" ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="this.language['system.user.name']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="applyAccount">
              <a-input v-model="model.applyAccount" placeholder="" :disabled="true"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="this.language['portal.personalName']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="applyName">
              <a-input v-model="model.applyName" placeholder="" :disabled="true"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item  :label="this.language['column.mailbox']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="applyEmail">
              <a-input v-model="model.applyEmail" placeholder="" :disabled="true"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="this.language['column.Landline']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="applyTelephone">
              <a-input v-model="model.applyTelephone" placeholder="" :disabled="true"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="this.language['emp.develop.applyNo']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="applyNo">
              <a-input v-model="model.applyNo" placeholder="" :disabled="true"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['basedata.remark']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="remark">
              <a-textarea v-model="model.remark" rows="2" :placeholder="language['common.pleaseInput']+language['basedata.remark']" />
            </a-form-model-item>
          </a-col>
<!--          <a-col :span="24">
            <a-form-model-item :label="this.language['emp.apptype.status']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="auditStatus">
              <a-input v-model="model.auditStatus_dictText" placeholder="" :disabled="true"></a-input>
            </a-form-model-item>
          </a-col>-->
          <a-col :span="24">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              prop="auditStatus"
              aria-label="状态" :label="language['emp.apptype.status']" >
              <j-dict-select-tag v-model="model.auditStatus" :allowClear="true" dictCode="emp_application_audit_status" :disabled="true"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="this.language['common.auditTime']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="auditTime" v-if="model.auditStatus != 'approving'">
              <j-date placeholder="" v-model="model.auditTime" :showTime="true" date-format="YYYY-MM-DD HH:mm:ss" style="width: 100%" :disabled="true" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="this.language['common.auditor']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="auditor" v-if="model.auditStatus != 'approving'">
              <a-input v-model="model.auditor" placeholder=""  :disabled="true" ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="this.language['portal.ui2.approvalComment']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="auditRemark" v-if="model.auditStatus != 'approving'">
              <a-textarea v-model="model.auditRemark" :placeholder="this.language['basedata.pleaseEnter']+this.language['portal.ui2.approvalComment']"  ></a-textarea>
            </a-form-model-item>
          </a-col>
<!--          <a-col :span="24">
            <a-form-model-item label="刪除标示" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="delFlag">
              <a-input v-model="model.delFlag" placeholder="请输入刪除标示"  ></a-input>
            </a-form-model-item>
          </a-col>-->
        </a-row>
      </a-form-model>
    </j-form-container>
    <language-model ref="languageModel" @ok="languageOk"></language-model>

    <a-card
      :bordered="false" :title="language['portal.ui2.approvalComment']"  v-if="model.auditStatus == 'approving'&&this.auditFlag" >
      <div >
        <a-row >
          <a-textarea v-model="model.auditRemark" :placeholder="this.language['basedata.pleaseEnter']+this.language['portal.ui2.approvalComment']"></a-textarea>
        </a-row>
        <br/>
        <div style="text-align: center;">
          <!--<a-button style="color: blue;" @click="agree" v-if="model.task_code==='ApproveTask8'">{{language['eletronicSigned.sendOut']}}</a-button>-->
          <a-button style="color: blue;right: 20px;padding-left: 30px;padding-right: 30px;" @click="agree"  >{{language['eletronicSigned.agree']}}</a-button>
          <a-button style="color: red;left: 20px;padding-left: 30px;padding-right: 30px;" @click="reject" >{{language['eletronicSigned.reject']}}</a-button>
        </div>
      </div>
    </a-card>
  </a-spin>

</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import LanguageModel from "@/components/LanguageModel"

  export default {
    name: 'EmpDevAppApplyForm',
    components: {
      LanguageModel,
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      },
      //是否審核標記
      auditFlag: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model:{
         },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        /*validatorRules: {
           applicationName: [
              { required: true, message: '请输入应用名称!'},
           ],
           applicationCode: [
              { required: true, message: '请输入应用编码!'},
           ],
           applicationImgPath: [
              { required: true, message: '请输入应用图标!'},
           ],
           applicationDesc: [
              { required: true, message: '请输入应用描述!'},
           ],
           applyAccount: [
              { required: true, message: '请输入申请人账号!'},
           ],
           applyName: [
              { required: true, message: '请输入申请人姓名!'},
           ],
           applyEmail: [
              { required: true, message: '请输入申请邮箱!'},
           ],
           applyTelephone: [
              { required: true, message: '请输入分机!'},
           ],
           applyNo: [
              { required: true, message: '请输入单据编号!'},
           ],
           joinType: [
              { required: true, message: '请输入加入类别!'},
           ],
           delFlag: [
              { required: true, message: '请输入刪除标示!'},
           ],
        },*/
        url: {
          add: "/hhemp/devapply/empdevappapply",
          edit: "/hhemp/devapply/empdevappapply",
          queryById: "/hhemp/devapply/empdevappapply/",
          audit: "/hhemp/devapply/audit",
          entranceList: "/hhemp/entrance/empcmsentrances?status=Y",
          apptypeList: "/hhemp/apptype/empbaseapptypes?publishStatus=up&pageNo=1&pageSize=10000",
        },
        applicationNameLanguages:[],
        applicationDescLanguages:[],
        entranceOptions:[],
        selectedEntrances:[],
        apptypeOptions:[],
        appData:[],
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
      language() {
        return this.$store.getters.language
      },
      validatorRules(){

        return {
          joinType: [
            { required: true, message: this.language['common.pleaseChoose'] + this.language['emp.develop.joinTypeTitle'] + '!'},
          ],
          entranceList: [
            { required: true, message: this.language['common.pleaseChoose'] + this.language['emp.develop.empEntrance'] + '!'},
          ],
          appType: [
            { required: true, message: this.language['common.pleaseChoose'] + this.language['emp.develop.appType'] + '!'},
          ],
          applicationCode: [
            { required: true, message: this.language['common.pleaseInput'] + this.language['emp.develop.appCode'] + '!'},
          ],
          applicationName: [
            { required: true, message: this.language['common.pleaseInput'] + this.language['emp.develop.appName'] + '!'},
            { validator: this.validateApplicationName },
          ],
          applicationDesc: [
            { required: true, message: this.language['common.pleaseInput'] + this.language['emp.develop.appDesc'] + '!'},
          ],
          applicationImgPath: [
            { required: true, message: this.language['food.pleaseUp'] + this.language['emp.develop.appIcon'] + '!'},
          ],
          applyType1: [
            { required: true, message: this.language['common.pleaseChoose'] + this.language['emp.develop.appType'] + '!'},
          ],

        }
      },
    },
    created () {
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
      this.initEntranceList();
      this.initApptypeList();

    },
    methods: {
      add () {
        this.edit(this.modelDefault);
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
        if(record.hasOwnProperty("id")){
          //this.getAppTypeApps(record.id);
          this.initLanguageName('emp_dev_app_apply','application_name',record.id)
          this.initLanguageDesc('emp_dev_app_apply','application_Desc',record.id)

        }
        this.selectedEntrances = this.model.entranceList;
        this.appData = this.model.appTypeList;
        this.entranceId = this.model.entranceList;
      },
      audit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
        if(record.hasOwnProperty("id")){
          //this.getAppTypeApps(record.id);
          this.initLanguageName('emp_dev_app_apply','application_name',record.id)
          this.initLanguageDesc('emp_dev_app_apply','application_Desc',record.id)

        }
        this.selectedEntrances = this.model.entranceList;
        this.appData = this.model.appTypeList;
        this.entranceId = this.model.entranceList;
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      languageModelOpen(dataTable,dataColumn,languagelist){
        this.$refs.languageModel.edit("hhemp",dataTable,dataColumn,this.model.id,languagelist,this.disabled);
      },
      languageOk(map){
        if(map&&map.dataColumn == 'application_name'){
          this.applicationNameLanguages = map.languagelist;
        }
        if(map&&map.dataColumn == 'application_desc'){
          this.applicationDescLanguages = map.languagelist;
        }
      },
      initLanguageName(dataTable,dataColumn,dataId) {
        getAction("/sys/syslanguagedata/querylistby", {
          applicationCode: "platform",
          dataTable: dataTable,
          dataColumn: dataColumn,
          dataId: dataId
        }).then((res) => {
          if (res.success) {
            this.applicationNameLanguages = res.result;
          }
        })
      },
      initLanguageDesc(dataTable,dataColumn,dataId) {
        getAction("/sys/syslanguagedata/querylistby", {
          applicationCode: "platform",
          dataTable: dataTable,
          dataColumn: dataColumn,
          dataId: dataId
        }).then((res) => {
          if (res.success) {
            this.applicationDescLanguages = res.result;
          }
        })
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      agree(){
        const that = this;
        that.confirmLoading = true;
        let httpurl = '';
        let method = '';
        httpurl+=this.url.audit;
        method = 'post';
        httpAction(httpurl,{
          id: this.model.id,
          auditRemark: this.model.auditRemark,
          auditType: 'agree'
        },method).then((res)=>{
          if(res.success){
            that.$message.success(res.message);
            that.$emit('ok');
          }else{
            that.$message.warning(res.message);
          }
        }).finally(() => {
          that.confirmLoading = false;
        })
      },
      reject(){
        const that = this;
        that.confirmLoading = true;
        if(this.model.auditRemark==undefined||this.model.auditRemark==""){
          that.$message.warning(this.language['basedata.pleaseEnter']+this.language['portal.ui2.approvalComment']);
          that.confirmLoading = false;
          return false;
        }

        let httpurl = '';
        let method = '';
        httpurl+=this.url.audit;
        method = 'post';
        httpAction(httpurl,{
          id: this.model.id,
          auditRemark: this.model.auditRemark,
          auditType: 'reject'
        },method).then((res)=>{
          if(res.success){
            that.$message.success(res.message);
            that.$emit('ok');
          }else{
            that.$message.warning(res.message);
          }
        }).finally(() => {
          that.confirmLoading = false;
        })
      },
      //初始化入口列表
      initEntranceList(){
        getAction(this.url.entranceList).then(res=>{
          if(res.success){
            this.entranceOptions = res.result.map((item,index,arr)=>{
              let c = {label:item.entranceName, value: item.id+""}
              return c;
            })
          }
        })
      },
      //初始化应用分类列表
      initApptypeList(){
        getAction(this.url.apptypeList).then(res=>{
          if(res.success){
            this.apptypeOptions = res.result.records.map((item,index,arr)=>{
              let c = {label:item.appTypeName, value: item.id+"",entranceId: item.entranceId}
              return c;
            })
          }
        })
      },
      handleChangeEntrance(event){
        this.selectedEntrances = event;
        this.entranceId = event;
        this.model.entranceList = event;

        for(let i = this.appData.length - 1; i >= 0 && this.appData.length>this.selectedEntrances.length; i--){
          if(this.appData.length>this.selectedEntrances.length){
            this.appData.splice(i, 1);
          }
        }
        let appDataNew = [];
        for (let i = 0; i<this.selectedEntrances.length; i++) {
          // 获取当前下标对应的值
          const index = this.selectedEntrances[i];
          const appTypeListTemp =  this.apptypeOptions.filter(temp => temp.entranceId === index);

          for(let j=0;j<appTypeListTemp.length;j++) {
            if (this.appData.length>j-1 && this.appData[i] == appTypeListTemp[j].value) {
              appDataNew.push(appTypeListTemp[j].value)
              break;
            }
          }

        }
        this.appData = appDataNew;

      },
      cale(temp){
        const foundItem = this.entranceOptions.find(item => item.value === temp);
        return  foundItem ? '('+foundItem.label+')' : '';
      },

    }
  }
</script>

<style scoped>

.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 40px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}

 .requiredCss::before {
   display: inline-block;
   margin-right: 4px;
   color: #f5222d;
   font-size: 14px;
   font-family: SimSun, sans-serif;
   line-height: 1;
   content: '*';
 }
</style>